<template>
    <div class="rules-modal-popup rules_m">
        <div class="modal fade success_submit" id="success_submit" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content edit-modal-i">
                    <div class="modal-header border-0 p-0">
                        <button type="button" class="btn-cl" data-bs-dismiss="modal" aria-label="Close"><img src="@/assets/images/close_m.svg" alt="m_close" @click="routeToHome()"/></button>
                    </div>
                    <div class="modal-body p-0 pt-3">
                        <div class="success_submit_modal">
                            <img src="@/assets/images/congratulations.svg" alt="bhopu" />
                            <div class="success_submit-title">Congratulations!</div>
                            <div class="success_submit-text">Deposit request of <span class="font-bold"></span> <span class="font-bold">{{amount}}</span> has been submitted. We will approve as soon as we detect the payment in our banks.</div>
                            <div class="w-full pt-0 pb-1 mt-0 flex items-center justify-center gap-x-3" >
                                <button class="submit_btn bg-titleGrd" type="button" @click="routeToHome()">
                                    Start Playing
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    name: 'DepositSuccessfully',
    props: ['amount'],
    methods:{
        routeToHome(){
            this.$helper.closeModal('success_submit');
            setTimeout(() => {
                this.$router.push({name: 'Home'});
            }, 500);
        }
    }
}
</script>